import { createTheme } from '@mui/material/styles';
export { ThemeProvider, createTheme, keyframes, styled, useTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: "#1D1C38",
            dark: "#1D1C38",
            light: "#FAFAFA",
            contrastText: "#FFFFFF",
        },
        secondary: {
            main: "#04D2C6",
            dark: "#01B2A8",
            light: "#FAFAFA",
            contrastText: "#FFFFFF",
        },
        success: {
            main: "#55BB18",
            light: "#F0FBEA",
            contrastText: "#FFFFFF",
        },
        error: {
            main: "#EA6767",
            light: "#FDF0F0",
            dark: "#EE8585",
            contrastText: "#FFFFFF",
        },
        info: {
            main: "#979797",
            light: "#F4F4F4",
            contrastText: "#FFFFFF",
        },
        warning: {
            main: "#F69400",
            light: "#FFF8EC",
            contrastText: "#FFFFFF",
        },
        text: {
            primary: "#4A4960",
            secondary: "#FFFFFF",
            disabled: "#979797",
        },
        grey: {
            50: "#FAFAFA",
            100: "#EBEBEB",
            200: "#DADADA",
            300: "#979797",
            400: "#8E8E9C",
            500: "#5F5F5F",
            600: "#6C6C6C",
            700: "#383838",
        },
        teal: {
            100: "#E6FBF9",
            200: "#CDF6F4",
            300: "#82E9E3",
            400: "#36DBD1",
            500: "#04D2C6",
            600: "#01B2A8",
            700: "#02948B",
            800: "#37736F",
        },
        orange: {
            50: "#FFF1D9",
            100: "#FFE6B3",
            200: "#FFD9A3",
            300: "#FFC775",
            400: "#FFB946",
            500: "#F69400",
            600: "#D97E00",
        },
        purple: {
            50: "#F2EFFF",
            100: "#E5DFFF",
            200: "#BDB0FF",
            400: "#7B61FF",
        },
        blue: {
            200: "#E6ECF9",
            300: "#3A89FF",
            500: "#3170EE",
        },
        graphColors: {
            green: "#55BB18",
            orange: "#F69400",
            purple: "#7B61FF",
            darkGrey: "#424242",
            yellow: "#F69400",
            blue: "#3170EE",
        },
        common: {
            white: "#FFFFFF",
            //@ts-ignore
            yellow: "#FFBA3F",
            purple: "#7B61FF",
            opacityTeal: "#04D2C61A",
            opacityTeal2: "#04D2C633",
            opacityPurple: "#7B61FF1A",
            grey: "#424242",
            black: "#000000",
        },
    },
    spacing: 10,
    typography: {
        fontFamily: "Roboto, -apple-system, BlinkMacSystemFont, 'Segoe UI', Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif",
        fontWeightLight: 300,
        fontWeightRegular: 400,
        fontWeightMedium: 500,
        fontWeightBold: 700,
        h1: {
            fontStyle: "normal",
            fontWeight: "300",
            fontSize: 28,
            lineHeight: "32px",
        },
        h2: {
            fontStyle: "normal",
            fontWeight: "normal",
            fontSize: 20,
            lineHeight: "28px",
        },
        h3: {
            fontStyle: "normal",
            fontWeight: "normal",
            fontSize: 16,
            lineHeight: "22px",
        },
        h4: {
            fontStyle: "normal",
            fontWeight: "normal",
            fontSize: 14,
            lineHeight: "21px",
        },
        h5: {
            fontStyle: "normal",
            fontWeight: "normal",
            fontSize: 13,
            lineHeight: "19px",
        },
        body1: {
            fontStyle: "normal",
            fontWeight: "normal",
            fontSize: 12,
            lineHeight: "18px",
        },
        body2: {
            fontStyle: "normal",
            fontWeight: "normal",
            fontSize: 10,
            lineHeight: "12px",
        },
        subtitle2: {
            fontStyle: "normal",
            fontWeight: "normal",
            fontSize: 8,
            lineHeight: "8px",
        },
    },
    components: {
        MuiIcon: {
            defaultProps: {
                // Replace the `material-icons` default value.
                color: "primary",
            },
        },
    },
});

export { theme as default, theme };
